import { render, staticRenderFns } from "./customList.vue?vue&type=template&id=77de48d2&scoped=true&"
import script from "./customList.vue?vue&type=script&lang=js&"
export * from "./customList.vue?vue&type=script&lang=js&"
import style0 from "./customList.vue?vue&type=style&index=0&id=77de48d2&prod&lang=css&"
import style1 from "./customList.vue?vue&type=style&index=1&id=77de48d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77de48d2",
  null
  
)

export default component.exports